import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "jquery"
import "../stylesheets/application.scss"
import "../javascripts/common.js"

Rails.start()
ActiveStorage.start()
